import { Manager } from "../../core";

export interface RatingAdmResponse {
	id: number;
	userId: string;
	comboId: number;
	cleaningDate: string | null;
	rate: number;
	feedback: string | null;
	createdAt: string;
	name: string;
	surname: string;
	email: string;
	plan: string;
	comboDate: string;
	teamName?: string;
}

export const getRatings = async () => {
	try {
		const {data} = await Manager.request(
			'get',
			'/admin/rating/list.php',
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.rating.get', err)
	}
}
